import omit from 'lodash/omit';
import {
  ADD_CART_ITEM_RESPONSE,
  REMOVE_CART_ITEM_RESPONSE,
  UPDATE_CART_ITEM_RESPONSE,
  CREATE_CART_RESPONSE,
  GET_CART_REQUEST,
  GET_CART_RESPONSE,
  GET_CART_ERROR,
  UPDATE_CART_REQUEST,
  UPDATE_CART_RESPONSE,
  CREATE_CHECKOUT_RESPONSE,
} from 'actions/pantry';

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  pantryCart: {
    id: '',
    subtotal: '$0.00',
    shippingAmount: 'FREE',
    total: '$0.00',
    orderNumber: 0,
    address: {},
    user: {},
  },
};

export default (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case UPDATE_CART_REQUEST:
    case GET_CART_REQUEST:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case GET_CART_ERROR:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
      };
    case GET_CART_RESPONSE:
    case UPDATE_CART_RESPONSE:
    case CREATE_CART_RESPONSE:
    case UPDATE_CART_ITEM_RESPONSE:
    case REMOVE_CART_ITEM_RESPONSE:
    case ADD_CART_ITEM_RESPONSE:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        pantryCart: omit(action.response.pantryCart, 'lineItems'),
      };
    case CREATE_CHECKOUT_RESPONSE:
      return initialState;
    default:
      return state;
  }
};
